import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { FieldArray } from 'redux-form';

import ServiceProvider from './ServiceProvider';
import { IconButton } from 'material-ui';
import ActionHistory from 'material-ui/svg-icons/action/history';
import ServiceProvidersHistoryDialog from '../../PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersHistoryDialog';

class ServiceProviders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openHistoryDialog: false,
            
        };
    }

    toggleHistoryDialog = () => {
        this.setState({
            openHistoryDialog: !this.state.openHistoryDialog,
        });
    }

    render() {
        const { openHistoryDialog } = this.state;
        return (
            <Fragment>
                <div style={{ margin: '0' }} className='main__title row'>
                    <div className='col-xs-11'>
                    Service providers
                    </div>
                    <div className='col-xs-1'>
                        <IconButton onClick={this.toggleHistoryDialog}>
                            <ActionHistory color='#B3B3B3' />
                        </IconButton>
                        
                    </div>
                </div>

                <div className='service-providers'>
                    <FieldArray
                        name="serviceProviders"
                        component={ServiceProvider}
                    />
                </div>
                <ServiceProvidersHistoryDialog
                    open={openHistoryDialog}
                    toggle={this.toggleHistoryDialog}
                />
            </Fragment>
        );
    }
}

ServiceProviders.propTypes = {

};

ServiceProviders.defaultProps = {

};

export default ServiceProviders;



// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/Component.jsx